<template>
  <div class="w-32 bg-blue-400 flex justify-center">
    <div class="py-2 text-white text-2xl">{{ remainingTime }}</div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: 'RoomExamTimer',
  components: {
  },
  computed: {
    ...mapState('exam', [
      'roomExam',
    ]),
    ...mapGetters('user', [
      'hasEmceeRole',
    ]),
  },
  data() {
    return {
      diffSeconds: 0,
      remainingSeconds: 0,
      remainingTime: '00:00:00',
    }
  },
  watch: {
    'roomExam.examDuration': {
      handler(examDuration) {
        if (!examDuration) {
          return;
        }

        this.setTimeSeconds(examDuration);
        this.setDuration(examDuration);
        this.startTimer(examDuration);
      },
      deep: true,
      immediate: true,
    }
  },
  destroyed() {
    clearTimeout(this._startTimer);
  },
  methods: {
    ...mapActions('exam', [
      'endExam',
    ]),
    ...mapMutations('exam', [
      'COMPLETE_USER',
    ]),

    setTimeSeconds(examDuration) {
      const now = Date.now();
      const beginDate = new Date(this.roomExam.beginDate).getTime();
      console.log('## init Start Timer now[%s] beginDate[%s]', now, beginDate);
      this.diffSeconds = Math.floor((now - beginDate) / 1000);
      if (this.diffSeconds <= 0) {
        this.diffSeconds = 0;
      }
      this.remainingSeconds = examDuration;
    },
    setDuration(examDuration) {
      this.remainingSeconds = this.remainingSeconds > 0 ? examDuration - this.diffSeconds : examDuration + this.diffSeconds;
      this.remainingTime = new Date(this.remainingSeconds * 1000).toISOString().substr(11, 8);
    },
    startTimer(examDuration) {
      this._startTimer = setTimeout(() => {
        examDuration -= 1;

        this.setDuration(examDuration);
        this.startTimer(examDuration);

        if (this.remainingSeconds <= 0) {
          clearTimeout(this._startTimer);

          if (this.hasEmceeRole()) {
            this.$alert(this.$t('testBank.alert.end.emcee'), () => {
              this.endExam();
            });
          } else {
            this.COMPLETE_USER();
            this.$alert(this.$t('testBank.alert.end.participant'));
          }
        }
      }, 1000);
    },
  }
}
</script>